// ─────────────────────────────────────────────────────────────────────────────
// Estrutura de navegação ÚNICA do app — usada pelo Sidebar (desktop),
// SidebarDrawer (menu mobile) e MobileBottomNav (barra inferior mobile).
// Ao adicionar uma rota nova: incluir aqui + pages{} no App.js + PLAN_FEATURES.
// ─────────────────────────────────────────────────────────────────────────────

export const NAV_GROUPS = [
  {
    group: 'GERAL',
    items: [
      { id: 'dashboard',    label: 'Dashboard',        icon: 'fa-house' },
      { id: 'transactions', label: 'Lançamentos',      icon: 'fa-list-ul' },
      { id: 'accounts',     label: 'Contas e Cartões', icon: 'fa-credit-card' },
      { id: 'categories',   label: 'Categorias',       icon: 'fa-tag' },
    ],
  },
  {
    group: 'PLANEJAMENTO',
    items: [
      { id: 'goals',            label: 'Metas',              icon: 'fa-star' },
      { id: 'budgets',          label: 'Orçamento Poderoso', icon: 'fa-clipboard-list' },
      { id: 'forecasts',        label: 'Previsões',          icon: 'fa-calendar-check' },
      { id: 'installments',     label: 'Parcelas',           icon: 'fa-layer-group' },
      { id: 'subscriptions',    label: 'Assinaturas',        icon: 'fa-repeat' },
      { id: 'investments',      label: 'Investimentos',      icon: 'fa-chart-bar' },
      { id: 'salary-division',  label: 'Divisão de Salário', icon: 'fa-scale-balanced' },
      { id: 'ai-consultor',     label: 'Consultor IA',       icon: 'fa-robot' },
    ],
  },
  {
    group: 'CONTROLE',
    items: [
      { id: 'debts',    label: 'Dívidas',  icon: 'fa-file-invoice-dollar' },
      { id: 'vehicles', label: 'Manutenções', icon: 'fa-screwdriver-wrench' },
    ],
  },
  {
    group: 'RELATÓRIOS',
    items: [
      { id: 'calendar',    label: 'Calendário',          icon: 'fa-calendar' },
      { id: 'reports',     label: 'Resumo Anual',        icon: 'fa-chart-line' },
      { id: 'month-report', label: 'Meu Mês',            icon: 'fa-share-nodes' },
      { id: 'card-report', label: 'Relatório de Cartão', icon: 'fa-chart-column' },
      { id: 'tax-report',  label: 'Imposto de Renda',    icon: 'fa-landmark' },
    ],
  },
  {
    group: 'SUPORTE',
    items: [
      { id: 'getting-started', label: 'Primeiros Passos', icon: 'fa-flag-checkered' },
      { id: 'plans',           label: 'Planos',           icon: 'fa-crown' },
      { id: 'help',            label: 'Ajuda',            icon: 'fa-circle-question' },
      { id: 'profile',         label: 'Configurações',    icon: 'fa-gear' },
    ],
  },
];

// Barra inferior fixa do mobile — os 4 destinos mais usados + botão central de adicionar
export const BOTTOM_NAV = [
  { id: 'dashboard',    label: 'Início',      icon: 'fa-house' },
  { id: 'transactions', label: 'Extrato',     icon: 'fa-list-ul' },
  // slot do meio = botão ➕ (renderizado à parte)
  { id: 'accounts',     label: 'Contas',      icon: 'fa-credit-card' },
  { id: 'reports',      label: 'Relatórios',  icon: 'fa-chart-line' },
];
